import { merchFormToQuery as formToQuery } from './merchFormToQuery';
import { merchQueryToForm as queryToForm } from './merchQueryToForm';

export default { queryToForm, formToQuery };
